import { useLogStreamsPermissionQuery } from "./operations.generated";

export function useCanAccessLogStreams(
  accountId: string | undefined,
  isLogStreamsEnabled: boolean
): boolean {
  const shouldFetchPermission = Boolean(accountId) && isLogStreamsEnabled;
  const { data, error, loading } = useLogStreamsPermissionQuery({
    fetchPolicy: "no-cache",
    skip: !shouldFetchPermission,
    variables: { accountId: accountId ?? "" },
  });

  if (!shouldFetchPermission || loading || error) {
    return false;
  }

  return data?.currentUser?.permissions?.canAccessLogStreams === true;
}
